import {
  GoogleGenerativeAI,
  SchemaType,
} from "@google/generative-ai";
import axios from "axios";
import { useState } from "react";

const apiKey = "AIzaSyDB2TRX7tEkCcOdDPe-CAneiPH1cxXXzaQ ";
const genAI = new GoogleGenerativeAI(apiKey);
const teacherAI = `"You are an interactive teacher guiding students through MCQs based on the CBSE curriculum (India) using real-world problems. Encourage independent thinking before revealing explanations. Do not provide direct answers; instead, guide students step-by-step. Evaluate responses strictly in JSON format after the first interaction.  

JSON Structure: {"reason_if_not_ai_generated":"String","is_response_ai_generated":Number,"off_topic":boolean,"is_correct":boolean,"is_penalty":boolean,"penalty_amount":Number,"penalty_reason":"String","response":"String"}  

Penalties: [
  { "slug": "off_topic", "name": "Off Topic", "penalty_amount": 0 },
  { "slug": "hint_used", "name": "Hint Used", "penalty_amount": 2 },
  { "slug": "answer_requested", "name": "Answer Requested", "penalty_amount": 5 },
  { "slug": "incorrect_answer", "name": "Incorrect Answer", "penalty_amount": 1 }
]  

Penalties apply as follows: Off Topic (0 XP) if unrelated, Hint Used (-2 XP) if guidance is requested, Answer Requested (-5 XP) if the answer is directly asked, Incorrect Answer (-1 XP) if the answer is wrong. Always respond strictly in JSON after the first interaction, with no additional text or explanations."
`;

// const teacherAI = `You are an interactive teacher guiding students through MCQs based on the CBSE curriculum (India) using real-world problems. Encourage independent thinking before revealing explanations. Do not provide direct answers; instead, guide students step-by-step.`;

// Decision Maker AI
const decisionAISysPrompt = "You are a decision maker. You will receive a question or a query and decide if this question or query is regarding a course recommendation. If the question is regarding the course recommendation then you will simple respond with YES else respond with NO"

const decisionMakerAI = new GoogleGenerativeAI(apiKey);
const decisionMakerModel = decisionMakerAI.getGenerativeModel({
  model: "gemini-2.0-flash",
  systemInstruction: decisionAISysPrompt,
});

// Recommendation AI
const recommendationAISysPrompt = "You are a recommendation teacher who wants to recommend courses to students based on their grade and subject. Only recommend courses that are relevant to the student's grade and subject. If the grade or subject is not know to you then make the best course recommendation from the provided list or context that aligns with the users query."
const recommendationAI = new GoogleGenerativeAI(apiKey);
const recommendationModel = recommendationAI.getGenerativeModel({
  model: "gemini-2.0-flash",
  systemInstruction: recommendationAISysPrompt,
});

// Grade and subject AI
const gradeAndSubjectAISysPrompt = "You are a grade and subject teacher who wants to get the grade and subject from the student's query. You will receive a query from the student and you will extract the grade and subject from the query. You will respond with a sentnece that contains the grade and subject. The sentece should be in the format of 'Grade <grade> subject <subject>'"
const gradeAndSubjectAI = new GoogleGenerativeAI(apiKey);
const gradeAndSubjectModel = gradeAndSubjectAI.getGenerativeModel({
  model: "gemini-2.0-flash",
  systemInstruction: gradeAndSubjectAISysPrompt,
});

// Grade and Subject AI - v2

// Schema for Grade and Subject as JSON output
const schema = {
  description: "Grade and Subject details",
  type: SchemaType.OBJECT,
    properties: {
      grade: {
        type: SchemaType.STRING,
        description: "Grade of the student",
        nullable: true,
      },
      subject: {
        type: SchemaType.STRING,
        description: "Subject of the student",
        nullable: true,
      }  
    },
};


const gradeAndSubjectAIv2SysPrompt = "You are a grade and subject teacher who wants to get the grade and subject from the student's query. You will receive a query from the student and you will extract the grade and subject from the query. You will respond with a JSON object that contains the grade and subject. The JSON object should be in the format given to you."
const gradeAndSubjectAIv2 = new GoogleGenerativeAI(apiKey);
const gradeAndSubjectAIv2Model = gradeAndSubjectAIv2.getGenerativeModel({
  model: "gemini-2.0-flash",
  systemInstruction: gradeAndSubjectAIv2SysPrompt,
  generationConfig: {
    responseMimeType: "application/json",
    responseSchema: schema,
  },
});

// Clarify AI
// Will be used if the user does not provide the grade or subject or both.
const clarifyAI = new GoogleGenerativeAI(apiKey);
const clarifyAIPrompt = `You are tasked with understanding the user query. If you are able to understand the grade and subject from the user provided query then respond with "PROCEED". If you don't understand the grade but understand the subject then respond with "GRADE". If you don't understand the subject but understand the grade then respond with "SUBJECT". If you don't understand both grade and subject then respond with "CLARIFY".`;
const clarifyModel = clarifyAI.getGenerativeModel({
  model: "gemini-2.0-flash",
  systemInstruction: clarifyAIPrompt,
});

const useChat = () => {
  const [systemPrompt, setSystemPrompt] = useState(teacherAI);
  const [modelType, setModelType] = useState("gemini-2.0-flash-thinking-exp");
  const [generationConfig, setGenerationConfig] = useState({
    temperature: 0.1,
    topP: 0.95,
    topK: 64,
    maxOutputTokens: 256,
    responseMimeType: "text/plain",
  });

  const [generatingMessage, setGeneratingMessage] = useState(false);
  const [messages, setMessages] = useState([]);
  const [attemptDetails, setAttemptDetails] = useState(null);
  const [initResponse, setInitResponse] = useState(null); // to store the initial response from the model
  // const [recommendations, setRecommendations] = useState(null);
  let chatSession;

  // Grade and Subject AI states
  const [grade, setGrade] = useState(null);
  const [subject, setSubject] = useState(null);

  // Descision States
  const [isRecommendationComplete, setIsRecommendationComplete] = useState(true);

  const model = genAI.getGenerativeModel({
    model: modelType,
    systemInstruction: systemPrompt,
  });

  async function startChat() {
    chatSession = model.startChat({
      ...generationConfig,
      history: messages.map((message) => {
        return { role: message.role, parts: [{ text: message.content }] };
      }),
    });
  }
  const sendMessage = async (userMessage, isInit = false, aiMode) => {
    setGeneratingMessage(true);

    if (!chatSession) {
      await startChat();
    }

    !isInit &&
      setMessages((messages) => [
        ...messages,
        { role: "user", content: userMessage },
      ]);

      // determine if the user is asking a general question or a decision making question
      const decisionResult = await decisionMakerModel.generateContent(userMessage);
      const decision = decisionResult.response.text();
      console.log("Decision for Course Recommendation: ", decision);
      console.log(typeof decision);

      // If decision is YES then proceed with the course recommendation
      // If the decision is NO then it could be that this request is a continuation of the previous decision that was YES, so use a state variable to determine if the previous decision was completed or not
      if(decision.trim().toLocaleUpperCase() === "YES" || isRecommendationComplete === false){
        // console.log("Decision is YES");
        // RAG Recommendation
        // call the pinecone searcher API
        // send a message back to the user
        // Render a custom component message if needed - Course Component is used to render the course recommendations
        // Handle scenerio where either grade or subject or both are missing 
        // If both are missing then ask the user to provide both - separate branching flow.
        // grade and subject should be fetched from the user prompt


        // Clarify AI Prompt Testing
        let clarifyResult = await clarifyModel.generateContent(userMessage);
        let clarify = clarifyResult.response.text();
        console.log("Clarify AI Response: ", clarify);


        let gradeAndSubjectResult = await gradeAndSubjectModel.generateContent(userMessage);
        let gradeAndSubject = gradeAndSubjectResult.response.text();
        console.log("Grade and Subject : ", gradeAndSubject);

        
        // Grade and Subject v2 AI
        let gradeAndSubjectResultv2 = await gradeAndSubjectAIv2Model.generateContent(userMessage);
        let gradeAndSubjectv2 = gradeAndSubjectResultv2.response.text();
        console.log("Grade and Subject v2 : ", JSON.parse(gradeAndSubjectv2));
        let gradeAndSubjectv2Parsed = JSON.parse(gradeAndSubjectv2);
        // if the grade and subject are not provided then ask the user to provide the grade and subject
        // if(gradeAndSubject.includes("Grade") || gradeAndSubject.includes("subject")){}

        // if(!JSON.parse(gradeAndSubjectv2).grade) {
        //   setMessages((messages) => [
        //     ...messages,
        //     { role: "model", content: "Can you help me with the grade for which you want the course?" },
        //   ]);
        //   setSubject(gradeAndSubject.subject);
        //   setIsRecommendationComplete(false);
        //   return
        // } 
        
        // if(!JSON.parse(gradeAndSubjectv2).subject) {
        //   setMessages((messages) => [
        //     ...messages,
        //     { role: "model", content: "Can you help me with the subject for which you want the course?" },
        //   ]);
        //   setGrade(gradeAndSubject.grade);
        //   setIsRecommendationComplete(false);
        //   return
        // }

        // if both grade and subject are provided then proceed with the course recommendation
        // if(grade && subject){
        //   gradeAndSubject = `Grade ${grade} subject ${subject}`;
        //   console.log("Grade and Subject (Dynamic Updated): ", gradeAndSubject);
        //   setIsRecommendationComplete(true);
        // }

        let config = {
          method: 'post',
          url: 'https://yumg3ntcr5.execute-api.ap-south-1.amazonaws.com/default/pinecone-searcher',
          data : {
            "query": gradeAndSubject,
          }
        };        

        const matchingCourses = await axios.request(config);
        console.log("Matching PineCone Courses: ", matchingCourses.data.matches);

        let relevantCourses = matchingCourses.data.matches;

        // if there are courses that were fetched from third party then add them to the context, if the grade OR subject are not provided
        if(!gradeAndSubjectv2Parsed.grade || !gradeAndSubjectv2Parsed.subject){
          if(matchingCourses.data.thirdPartyMatches) {
            console.log("Third Party Courses were also fetched")
            if(matchingCourses.data.thirdPartyMatches.harvard.length > 0){
              console.log("Harvard Courses were fetched");
              relevantCourses = [...relevantCourses, ...matchingCourses.data.thirdPartyMatches.harvard];
            }
          }
        }

        const context = relevantCourses.map(doc => `${doc.metadata.title}: ${doc.metadata.description}`).join("\n");

        console.log("Checking Context : ", context);

        // // Re Rank the Courses based on the context
        // relevantCourses = relevantCourses.map(course => {
        //   return {
        //     id: course.id,
        //     text: `${course.metadata.title} - ${course.metadata.description}`,
        //     score: course.score,
        //     metadata: course.metadata
        //   }
        // })
        // console.log("Relevant Courses(Formatted for Re-Ranking): ", relevantCourses);

        
        // const reRankerResponse = await axios.post(`https://bhaskarcg-baai-bge-reranker-v2-m3.hf.space/v2/rerank`, {
        //     query: gradeAndSubject,
        //     documents: relevantCourses
        // }, {
        //     headers: {
        //         'Authorization': `Bearer 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`
        //     }    
        // });

        // console.log("ReRanked Courses : ", reRankerResponse.data.reranked_documents);

        let promptWithContext = `Based on the courses given by the context as ${context}.\n Make the best course recommendation that was asked for ${gradeAndSubject}`

        let recommendationResult = await recommendationModel.generateContent(promptWithContext);
        let recommendation = recommendationResult.response.text() + '\n\n' + "See below the courses that I have found based on your query."; 
        console.log("Recommendation : ", recommendation);

        // push model response in messages and return
        if(gradeAndSubjectv2Parsed.grade && gradeAndSubjectv2Parsed.subject) {
          setMessages((messages) => [
            ...messages,
            { role: "model", content: recommendation, courseRecommendations: relevantCourses },
          ]);
        } else {
          setMessages((messages) => [
            ...messages,
            { role: "model", content: recommendation, courseRecommendations: relevantCourses, thirdPartyMatches: matchingCourses.data.thirdPartyMatches.harvard },
          ]);
        }


        // Make a recommendation and return to the normal flow
        setGeneratingMessage(false);
        return
      } 

      // if decision is NO then continue with the normal flow
      console.log("User Message : ", userMessage);
    const result = await chatSession.sendMessage(userMessage);
    const message = result.response.text();
    if (!isInit && aiMode) {
      let parsedResponse =
        JSON.parse(message.replaceAll("`", "").replace("json", "")) || null;
      let response = "";
      let recommendations = null;
      if (parsedResponse) {
        console.log("Parsed Response : ", parsedResponse);

        let config = {
          method: 'post',
          // url: 'https://ioi1sbpvaf.execute-api.ap-south-1.amazonaws.com/v1/get-recomm',
          url: 'https://6b9vw0i7oj.execute-api.ap-south-1.amazonaws.com/v1/get-recomm-v1',
          data : {
            "query": parsedResponse.response + "\nfor Grade 6",
          }
        };

        let recommendationResponse = await axios.request(config);
        let parsedRecommedationResponse = JSON.parse(recommendationResponse.data.body).data;

        if(parsedRecommedationResponse?.matches){
          recommendations = parsedRecommedationResponse.matches;
        }

        // if(recommendationResponse.)
        setAttemptDetails(parsedResponse);
        response = parsedResponse.response;
      } else {
        setAttemptDetails(null);
        response = message;
      }
      !isInit &&
        setMessages((messages) => [
          ...messages,
          { role: "model", content: response, recommendations: recommendations },
        ]);
    }


    if (isInit) {
      console.log(
        "Initial Response of AI : ",
        messages,
        JSON.parse(message.replaceAll("`", "").replace("json", ""))
      );
      setInitResponse(
        JSON.parse(message.replaceAll("`", "").replace("json", ""))
      );
    }

    if (!aiMode && !isInit) {
      setMessages((messages) => [
        ...messages,
        { role: "model", content: message },
      ]);
    }
    setGeneratingMessage(false);

  };

  return {
    generationConfig,
    setGenerationConfig,
    setModelType,
    systemPrompt,
    setSystemPrompt,
    messages,
    sendMessage,
    initResponse,
    setMessages,
    attemptDetails,
    generatingMessage,
    model
  };
};

export default useChat;
